var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.324 212.148h122.088c0-6.917-.057-11.169 1.644-18.029h-122.229v-166.081h424.318v166.082h-122.23c1.701 6.86 1.673 11.112 1.673 18.029h122.088c9.071 0 16.526-7.427 16.526-16.526v-169.116c0-9.071-7.455-16.498-16.526-16.498h-427.352c-9.099 0-16.526 7.427-16.526 16.498v169.115c0 9.099 7.427 16.526 16.526 16.526z",
    fill: "#2f3a4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.817 40.028h400.337v142.073h-114.747c-7.88-14.882-22.592-25.597-40.28-32.145 7.143-9.468 11.395-21.26 11.395-34.044 0-31.209-25.313-56.523-56.523-56.523s-56.551 25.313-56.551 56.523c0 12.784 4.252 24.576 11.395 34.044-17.688 6.548-32.4 17.263-40.252 32.145h-114.774z",
    fill: "#116fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.568 220.453v-12.671c0-24.548-18.85-40.62-43.568-48.274-20.891 17.263-51.137 17.263-72.028 0-24.718 7.654-43.569 23.726-43.569 48.274v12.671z",
    fill: "#2f3a4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 71.38c24.576 0 44.532 19.956 44.532 44.532s-19.956 44.561-44.532 44.561-44.561-19.956-44.561-44.561 19.956-44.532 44.561-44.532z",
    fill: "#2f3a4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.833 347.616h24.265c8.702-20.041 28.658-34.072 51.902-34.072s43.172 14.031 51.874 34.072h24.264c-2.636-32.513 22.535-60.378 54.879-61.2v-14.825h-262.063v14.825c32.372.822 57.543 28.687 54.879 61.2z",
    fill: "#116fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.954 259.6h262.063c5.187 0 9.439-4.252 9.439-9.468v-8.22c0-5.216-4.252-9.468-9.439-9.468h-262.063c-5.188 0-9.439 4.252-9.439 9.468v8.22c0 5.216 4.252 9.468 9.439 9.468z",
    fill: "#116fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2f3a4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.912 474.863h120.501v-12.926c0-23.357 13.266-40.224 31.578-50.882-7.654-11.537-20.891-19.701-36.482-24.52-20.891 17.263-51.137 17.263-72.028 0-24.718 7.625-43.569 23.726-43.569 48.246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.48 298.406c24.605 0 44.561 19.928 44.561 44.532s-19.956 44.532-44.561 44.532-44.532-19.927-44.532-44.532 19.956-44.532 44.532-44.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.588 474.863h120.501v-40.082c0-24.52-18.879-40.592-43.597-48.246-20.891 17.263-51.109 17.263-72 0-15.591 4.819-28.857 12.982-36.51 24.52 18.312 10.658 31.606 27.524 31.606 50.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.491 298.406c24.605 0 44.532 19.928 44.532 44.532s-19.927 44.532-44.532 44.532-44.532-19.927-44.532-44.532 19.927-44.532 44.532-44.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.403 501.991h159.165v-40.054c0-24.548-18.85-40.62-43.568-48.274-20.891 17.263-51.137 17.263-72.028 0-24.718 7.654-43.569 23.726-43.569 48.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 325.534c24.576 0 44.532 19.956 44.532 44.532s-19.956 44.561-44.532 44.561-44.561-19.956-44.561-44.561 19.956-44.532 44.561-44.532z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLecture);
export default __webpack_public_path__ + "static/media/lecture.3c3fffca705291760f4a820715c09f3e.svg";
export { ForwardRef as ReactComponent };